/**
 * Shared chat attachment helpers (PWA + web-admin).
 * Keep in sync — imported via @shared/chat-media from both apps.
 */

/** Message content placeholder for photo uploads (hidden in bubble when attachment exists). */
export const CHAT_PHOTO_PLACEHOLDER = '[Фото]';

/** Max attachment size for chat uploads (photos, docs, voice). */
export const CHAT_ATTACHMENT_MAX_BYTES = 25 * 1024 * 1024;

/** Fallback aspect ratio when server did not store image_width / image_height. */
export const CHAT_IMAGE_ASPECT_FALLBACK = '4/3';

const IMAGE_NAME_EXT = /\.(jpe?g|png|gif|webp|heic|heif)$/i;

export function isProbablyImageFile(file: File): boolean {
  const t = (file.type || '').toLowerCase();
  if (t.startsWith('image/')) return true;
  return IMAGE_NAME_EXT.test(file.name || '');
}

export function isImageChatAttachment(att: {
  mime_type?: string | null;
  file_name?: string | null;
}): boolean {
  const m = (att.mime_type || '').toLowerCase();
  if (m.startsWith('image/')) return true;
  const n = (att.file_name || '').toLowerCase();
  return IMAGE_NAME_EXT.test(n);
}

/**
 * Append stream=true so GET /api/v1/files/... returns 200 body (S3) instead of 307 — better for WebView / media tags.
 */
/** Signed file URL (`sig` + `exp` query) — fetch with credentials omit. */
export function isSignedFileUrl(url: string): boolean {
  if (!url || typeof url !== 'string') return false;
  try {
    const u = new URL(url);
    return u.searchParams.has('sig') && u.searchParams.has('exp');
  } catch {
    return /[?&]sig=/.test(url) && /[?&]exp=/.test(url);
  }
}

export function withStreamQuery(url: string): string {
  if (!url || typeof url !== 'string') return url;
  try {
    const u = new URL(url);
    u.searchParams.set('stream', 'true');
    return u.toString();
  } catch {
    return url;
  }
}

export function chatImageAspectRatio(
  width?: number | null,
  height?: number | null
): string {
  if (width && height && width > 0 && height > 0) {
    return `${width}/${height}`;
  }
  return CHAT_IMAGE_ASPECT_FALLBACK;
}
